/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Transparent_Background_LabelInputs */



/**
* | output |
* | --- |
* | "Transparent Background (Alpha)" |
*
* @param {Image_Export_Transparent_Background_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_transparent_background_label = /** @type {((inputs?: Image_Export_Transparent_Background_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Transparent_Background_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arriere-plan transparent (Alpha)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transparenter Hintergrund (Alpha)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sfondo trasparente (Alfa)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прозрачный фон (альфа-канал)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fondo transparente (alfa)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("透明背景（Alpha通道）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("透明な背景（アルファ）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पारदर्शी पृष्ठभूमि (अल्फा)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fundo transparente (alfa)")
	return /** @type {LocalizedString} */ ("Transparent Background (Alpha)")
});